type HEX = `#${string}`;

export interface Palette {
  white: HEX;
  black: HEX;
  primary: {
    x50: HEX;
    x200: HEX;
    x400: HEX;
    x500: HEX;
    x600: HEX;
    x700: HEX;
    default: HEX;
  };
  secondary: {
    x500: HEX;
    default: HEX;
  };
  success: {
    x50: HEX;
    x200: HEX;
    x500: HEX;
    x700: HEX;
    default: HEX;
  };
  danger: {
    x50: HEX;
    x200: HEX;
    x500: HEX;
    x700: HEX;
    default: HEX;
  };
  warning: {
    x50: HEX;
    x200: HEX;
    x500: HEX;
    x700: HEX;
    default: HEX;
  };
  grey: {
    x50: HEX;
    x100: HEX;
    x200: HEX;
    x300: HEX;
    x400: HEX;
    x500: HEX;
    x600: HEX;
    x900: HEX;
    default: HEX;
  };
}

export const lightThemePalette: Palette = {
  white: '#FFFFFF',
  black: '#000000',
  primary: {
    x50: '#F3EBFF',
    x200: '#D8D2F2',
    x400: '#9788F7',
    x500: '#6400FF',
    x600: '#5000C8',
    x700: '#4200A4',
    default: '#6400FF',
  },
  secondary: {
    x500: '#D7EBEB',
    default: '#D7EBEB',
  },
  success: {
    x50: '#E6FBF2',
    x200: '#B6F0D7',
    x500: '#00D278',
    x700: '#00854C',
    default: '#00D278',
  },
  danger: {
    x50: '#FFF4F2',
    x200: '#F5C9BF',
    x500: '#FF6242',
    x700: '#D13D1A',
    default: '#FF6242',
  },
  warning: {
    x50: '#FEF7DE',
    x200: '#F8EDC7',
    x500: '#F5C51B',
    x700: '#947300',
    default: '#F5C51B',
  },
  grey: {
    x50: '#F7F8F9',
    x100: '#F0F2F7',
    x200: '#E3E7F0',
    x300: '#CCD1DC',
    x400: '#A4AAB7',
    x500: '#6C717C',
    x600: '#43464D',
    x900: '#161619',
    default: '#6C717C',
  },
};

export const darkThemePalette: Palette = {
  white: '#FFFFFF',
  black: '#000000',
  primary: {
    x50: '#272242',
    x200: '#3F357C',
    x400: '#7357FE',
    x500: '#9B87FF',
    x600: '#5000C8',
    x700: '#D7C9FF',
    default: '#C0B4FF',
  },
  secondary: {
    x500: '##ACBCBC',
    default: '##ACBCBC',
  },
  success: {
    x50: '#163025',
    x200: '#2A6F52',
    x500: '#00D278',
    x700: '#4FE9A7',
    default: '#00D278',
  },
  danger: {
    x50: '#2F1714',
    x200: '#642922',
    x500: '#FF6242',
    x700: '#FF746B',
    default: '#FF6242',
  },
  warning: {
    x50: '#322806',
    x200: '#56450B',
    x500: '#F5C51B',
    x700: '#FFDB5E',
    default: '#F5C51B',
  },
  grey: {
    x50: '#0A0A0C',
    x100: '#1A1B1D',
    x200: '#252628',
    x300: '#434549',
    x400: '#676A71',
    x500: '#91959D',
    x600: '#B9BDC6',
    x900: '#F0F2F7',
    default: '#91959D',
  },
};
